export { default as LoginSingleSignOnCustomer } from './login-single-sign-on-customer';
